<template>
	<app-container id="programs" class="text-xs-center">
		<v-layout>
			<v-flex>
				<h1>Our Programs</h1>
			</v-flex>
		</v-layout>

		<v-layout justify-center align-center>
			<v-flex md1 lg2 class="hidden-sm-and-down">
				<app-img src="/img/stars-vertical.png" class="stars-img" />
			</v-flex>

			<v-flex md9 lg7>
				<v-expansion-panel popout>
					<v-expansion-panel-content v-for="program in programsData" :key="program.title">
						<template v-slot:header>
							<div class="vertical-center-items">
								<app-img v-wh="32" :data-src="'/img/' + program.img" class="mr-3" />
								<b><span class="mx-1" v-html="program.title" /></b>
								<span class="mx-1 prog-desc" v-html="program.desc" />
							</div>
						</template>
						<v-card class="text-xs-center">
							<v-card-text>
								<p class="para-justified px-4">{{ program.para }}</p>
							</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-flex>

			<v-flex md1 lg2 class="hidden-sm-and-down">
				<app-img data-src="/img/stars-vertical-flipped.png" class="stars-img" />
			</v-flex>
		</v-layout>

		<v-divider width="50%" class="mx-auto my-3" />

		<v-layout>
			<v-flex>
				<p class="activities">
					<b>Note:</b>
					<app-img v-wh="24" data-src="/img/karate.png" class="mx-2" />
					Karate and Dance classes are incorporated into our curriculum each week for Toddlers, PreK 1, and PreK 2.
					<app-img v-wh="24" data-src="/img/musical-notes.png" class="ml-2" />
				</p>
			</v-flex>
		</v-layout>
	</app-container>
</template>

<script>
export default {
	data: () => ({
		programsData: [
			{
				title: 'Infants',
				desc: '(6 weeks - 18 months)',
				img: 'blue-pacifier.png',
				para: `
					We provide a warm, gentle, caring environment and focus on helping your baby reach all their milestones.
					Our curriculum incorporates age-appropriate and enjoyable activities to help develop essential skills including proper emotional and social behavior, communication, and fine motor skills.
					The classroom is equipped with toys for stimulation, nurturing, exploration, and growth.
					Classical music or lullabies play in the background providing a tranquil setting allowing babies to relax and sleep comfortably.
					Some of our daily activities include tummy time, sign language, singing songs, reading books, arts and crafts, peekaboo, stroller rides outside in our secure lot, and free play.
				`,
			}, {
				title: 'Waddlers',
				desc: '(18 months - 2 years)',
				img: 'teddy-bear.png',
				para: `
					Our Waddler room is designed with your young walker specifically in mind.
					We continue to provide the same warm and gentle care as the infant room, while incorporating all the new activities you're growing baby is learning.
					Our curriculum focuses on emotional and social behavior, fine and gross motor skills, early cognitive and communication skills, and physical growth.
					The classroom is equipped with toys to prepare your baby for the next stage of development in our toddler room.
					Some of our daily activities include strengthening their walking skills, building core muscles, circle time, arts and crafts, outdoor play, story time, sign language, free play, and imaginative play.
				`,
			}, {
				title: 'Toddlers',
				desc: '(2 - 3 years)',
				img: 'abc.png',
				para: `
					Toddlers are entering their curious stage of development and are gaining a sense of independence; they are little "sponges" and are absorbing everything around them.
					Our program promotes an environment based on structured and guided interaction.
					We focus on improving gross and fine motor skills, developing language, nourishing social and emotional bonds, cognitive, and physical growth.
					The classroom is equipped with age-appropriate learning stations, such as our reading corner, art studio, play area, and imagination station to name a few.
					We have weekly and monthly themes that we use to create a fun and easy learning atmosphere.
					Some of our daily activities include learning about numbers, letters, colors, shapes, participating in pretend play, arts and crafts, reading, circle time, sing-along songs, outdoor play, sign language, Spanish, yoga, and free play.
				`,
			}, {
				title: 'Pre-K 1 & 2',
				desc: '(3 - 5<sup>1</sup>&frasl;<sub>2</sub> years)',
				img: 'pencil-paper.png',
				para: `
					We prepare our Pre-K children for a smooth and confident transition to kindergarten by continuing to provide them with the best tools to succeed.
					Our Pre-K program is run by a New Jersey certified teacher, and a staff that makes learning a magical experience.
					Children learn physically, emotionally, socially, and intellectually by being immersed in our weekly and monthly themes and lessons.
					Whether they are playing, reading, doing arts and crafts, or in an educational station, the children are encouraged to express themselves.
					Our curriculum consists of language arts, mathematics, science, social studies, music and the arts, Spanish, sign language, computer skills, yoga, and outdoor play.
					The Pre-K program is on our second floor so children can better focus and have their own "big kid" space.
				`,
			}, {
				title: 'Before and After Care',
				desc: '',
				img: 'school-bus.png',
				para: `
					All Star Kids Academy opens at 6:30 AM and serves our students breakfast before being bused to their elementary and middle schools Peter Cooper, Hewitt, Ryerson, Wanaque, and Haskell.
					Ringwood private schools also may accommodate busing for Ringwood residents.
					Our spacious second floor, complete with a separate homework room and computer lab is dedicated to our school age children.
					After school, the children have a designated time to complete their homework in a group setting with the guidance of teachers.
					The children have access to the outdoor playground, as well as our "hang out" corner that has two flat screen TVs and age-appropriate video games.
					Students are also able to participate in other activities such as drawing, Arts and crafts, Lego table, dance competitions, scavenger hunts, and movies to name a few.
					We strive to create an environment where children are not only safe and learning but also having an enjoyable experience with their friends.
				`,
			}, {
				title: 'Summer',
				desc: '',
				img: 'sun.png',
				para: `
					All Star Kids Academy's summer program commences the first day following public school dismissal for the summer.
					Our hours remain Monday through Friday 6:30 AM to 7:00 PM with flexible days and hours altered to your needs.
					Since it is the summer we have a more relaxed schedule for our big kids and try to have as much fun with them as possible, while still being educational.
					Some of our activities are arts and crafts, bounce house, outdoor rock water activities, sandbar, beading, scavenger hunts, boardgames, bingo, reptile shows, field trips, karaoke, and movies.
				`,
			},
		],
	}),
}
</script>

<style>
.stars-img {
	min-height: 275px;
	max-height: 275px;
	opacity: 0.5;
}
.activities * {
	display: inline;
	vertical-align: middle;
}
@media (max-width: 420px) {
	.prog-desc {
		font-size: 92%;
	}
	.v-expansion-panel__header {
		padding: 16px 8px;
	}
}
</style>
